import { PAGE_TYPE_CART } from 'shared/consts'
import { TENANT_IT } from 'shared/consts/tenants'
import {
  CART_VOUCHER_INPUT_CLICK,
  CART_VOUCHER_SUBMIT_CLICK,
  CART_WORDING_IT,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import trackEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'
import { SPA_CART } from 'views/consts'

export default async () => {
  const { isEnabled } = getExperimentOnClient(CART_WORDING_IT)
  const { pageType } =
    store.getState()?.publicRuntimeConfig.pageProperties || {}
  const { tenant } = store.getState()?.publicRuntimeConfig.publicConfig || {}

  if (!isEnabled) return

  if (isEnabled && pageType === PAGE_TYPE_CART && tenant === TENANT_IT) {
    await activateExperiment(CART_WORDING_IT)

    const cartWrapperEl = document.getElementById(SPA_CART)

    cartWrapperEl?.addEventListener('click', event => {
      const element = <HTMLElement>event.target
      if (element.closest('.m-FormControlWithFloatingLabel')) {
        trackEvent(CART_VOUCHER_INPUT_CLICK)
      }
      if (element.closest('[data-qa-id~="form-voucherBox-submit"]')) {
        trackEvent(CART_VOUCHER_SUBMIT_CLICK)
      }
    })
  }
}
